import { GetStaticProps } from 'next'

export { default } from '@/components/pages/ShutdownPage'

export const getStaticProps: GetStaticProps = async () => {
  return { props: { domain: 'invest.angel.com' } }
}
